<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>
  <div class="section" *ngFor="let section of data.sections">
    <span class="heading-text" *ngIf="!!section.title">{{
      section.title
    }}</span>

    <table mat-table [dataSource]="section.table.rows">
      <ng-container
        *ngFor="let header of section.table.headers"
        [matColumnDef]="header.key"
      >
        <th mat-header-cell *matHeaderCellDef>{{ header.title }}</th>
        <td mat-cell *matCellDef="let element">{{ element[header.key] }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="headerRowList(section)"></tr>

      <tr mat-row *matRowDef="let row; columns: headerRowList(section)"></tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close color="primary">Close</button>
</mat-dialog-actions>
